import { crudRequest } from '@/services/api';
import { dateDiffCalculation } from '@/utils/date';
import { message } from 'antd';
import moment from 'moment';
import BaseTable from '../baseTable';

const PlanApiApi = {
  1: '/api/forecastpath/queryFirstVersion',
  2: '/api/forecastpath/queryLatestVersion',
  3: '/api/forecastpath/queryMultiVersion'
}

const params = {
  numberNo: '',
};

export default {
  namespace: 'centerroutetrajectorynew',
  state: {
    searchParams: { ...params },
    dataList: [],// 0实际,1预报,2计划,3最优
    briefingMsg: '',
    palnDataApi: '1'
  },
  effects: {
    *getDatas(_, { put, select }) {
      const { searchParams: { numberNo }, palnDataApi } = yield select(({ centerroutetrajectorynew }) =>
       centerroutetrajectorynew);

      const dataList = []
      const noLen = numberNo.length
      if (!noLen || (noLen !== 12 && noLen !== 20)) {
       return message.warning("运单号长度为12位，子单号长度为20位，请输入正确单号！")
      }
      for (let i = 0; i < BaseTable.length; i++) {
        const tableItem = BaseTable[i];
        const param = { tableName: tableItem.tableName, namespace: 'route_rs' }
        let apiUrl = ''
        if (noLen === 12) {
          apiUrl = '/api/route/hbase/queryByWayPrefixVer'
          param.waybillNo = numberNo
        } else if (noLen === 20) {
          apiUrl = '/api/route/hbase/queryBySubPrefixVer'
          param.subBillNo = numberNo
        }
        if (tableItem.tableNane === '计划') {
          apiUrl = PlanApiApi[palnDataApi]
        }
        const result = yield crudRequest(apiUrl, param)
        const data = result?.data?.map((m, i) => ({ ...m,  key: i })) || []
        dataList.push(data)
      }
      yield put({ type: 'updateState', payload: { dataList } })
    },
  },

  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
    searchParamsUpdate(state, { payload }) {
      const searchParams = { ...state.searchParams, ...payload };
      return { ...state, searchParams };
    },
    resetSearchParam(state) {
      return { ...state, searchParams: { ...params } };
    },
  },
};
